import React from "react";
import { formatCurrency } from "../../utils/dashboardUtils";

const KpiSection = ({ insights }) => {
  return (
    <div className="kpi-grid">
      <div className="kpi-card">
        <div className="kpi-label">Total Visits</div>
        <p className="kpi-value">{insights.totalVisits}</p>
        <span className="kpi-footnote">Visits in selected range</span>
      </div>
      <div className="kpi-card">
        <div className="kpi-label">Today Visits</div>
        <p className="kpi-value">{insights.todayVisits}</p>
        <span className="kpi-footnote">Appointments marked for today</span>
      </div>
      <div className="kpi-card">
        <div className="kpi-label">Unique Patients</div>
        <p className="kpi-value">{insights.uniquePatients}</p>
        <span className="kpi-footnote">Members + dependents</span>
      </div>
      <div className="kpi-card">
        <div className="kpi-label">Collected Amount</div>
        <p className="kpi-value">{formatCurrency(insights.collectedAmount)}</p>
        <span className="kpi-footnote">PaidAmount total</span>
      </div>
      <div className="kpi-card">
        <div className="kpi-label">Revisit Rate</div>
        <p className="kpi-value">{insights.revisitRate}%</p>
        <span className="kpi-footnote">Returning patients</span>
      </div>
    </div>
  );
};

export default KpiSection;
